import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import './AdminUsersMember.css';
const AdminUsersMember = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'users'));
        setUsers(snapshot.docs.map(d => ({
          id: d.id,
          ...d.data()
        })));
      } catch (err) {
        console.error('Error fetching users:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const getLevelsCount = (user) => {
    const code = user.referralCode;
    const level1 = code
      ? users.filter(u => u.whoReferredWho === code)
      : [];

    const codes1 = level1.map(u => u.referralCode).filter(Boolean);
    const level2 = users.filter(u =>
      u.whoReferredWho &&
      codes1.includes(u.whoReferredWho)
    );

    const codes2 = level2.map(u => u.referralCode).filter(Boolean);
    const level3 = users.filter(u =>
      u.whoReferredWho &&
      codes2.includes(u.whoReferredWho)
    );

    return { level1, level2, level3 };
  };

  const filteredUsers = users.filter(u => {
    const term = searchTerm.toLowerCase();
    return (
      String(u.username || '').toLowerCase().includes(term) ||
      String(u.fullName || '').toLowerCase().includes(term)
    );
  });

  const selectedLevels = selectedUser
    ? getLevelsCount(selectedUser)
    : null;

  const panelStyle = {
    background: '#ffffff',
    color: '#172033',
    border: '1px solid #dbe3ef',
    borderRadius: '12px',
    padding: '16px',
    boxShadow: '0 3px 12px rgba(0,0,0,0.06)'
  };

  if (loading) {
    return (
      <div style={{ background: '#fff', color: '#172033', padding: 24 }}>
        Inapakia taarifa za watumiaji...
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      gap: 20,
      padding: 20,
      background: '#f5f7fb',
      color: '#172033',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      <div style={{ ...panelStyle, flex: '1 1 600px', minWidth: 0 }}>
        <h2>Muhtasari wa Wanachama</h2>

        <input
          type="text"
          placeholder="Tafuta jina au username..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            padding: 12,
            width: '100%',
            maxWidth: 400,
            boxSizing: 'border-box',
            border: '1px solid #cbd5e1',
            borderRadius: 8,
            background: '#fff',
            color: '#172033',
            marginBottom: 16
          }}
        />

        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            textAlign: 'left',
            background: '#fff',
            color: '#172033'
          }}>
            <thead>
              <tr style={{ background: '#eaf0ff' }}>
                {['Username', 'Jina Kamili', 'Level 1', 'Level 2', 'Level 3'].map(title => (
                  <th key={title} style={{
                    padding: 12,
                    borderBottom: '1px solid #dbe3ef',
                    whiteSpace: 'nowrap'
                  }}>
                    {title}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {filteredUsers.map(user => {
                const levels = getLevelsCount(user);
                const selected = selectedUser?.id === user.id;

                return (
                  <tr
                    key={user.id}
                    onClick={() => setSelectedUser(user)}
                    style={{
                      cursor: 'pointer',
                      background: selected ? '#dbeafe' : '#ffffff',
                      color: '#172033'
                    }}
                  >
                    <td style={cellStyle}>{user.username || '—'}</td>
                    <td style={cellStyle}>{user.fullName || '—'}</td>
                    <td style={cellStyle}>{levels.level1.length}</td>
                    <td style={cellStyle}>{levels.level2.length}</td>
                    <td style={cellStyle}>{levels.level3.length}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {filteredUsers.length === 0 && (
          <p>Hakuna mtumiaji aliyepatikana.</p>
        )}
      </div>

      <div style={{ ...panelStyle, flex: '0 1 300px', minWidth: 250 }}>
        {selectedUser ? (
          <>
            <h3 style={{ overflowWrap: 'anywhere' }}>
              Rufaa za {selectedUser.username || selectedUser.fullName || 'Mtumiaji'}
            </h3>

            {[
              ['Level 1', selectedLevels.level1],
              ['Level 2', selectedLevels.level2],
              ['Level 3', selectedLevels.level3]
            ].map(([title, members]) => (
              <div key={title} style={{ marginBottom: 18 }}>
                <strong>{title} ({members.length})</strong>
                {members.length ? (
                  <ul>
                    {members.map(member => (
                      <li key={member.id}>
                        {member.username || member.fullName || member.id}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p style={{ color: '#64748b' }}>Hakuna wanachama.</p>
                )}
              </div>
            ))}

            <button
              onClick={() => setSelectedUser(null)}
              style={{
                padding: '9px 14px',
                background: '#e2e8f0',
                color: '#172033',
                border: 0,
                borderRadius: 8,
                cursor: 'pointer'
              }}
            >
              Funga taarifa
            </button>
          </>
        ) : (
          <p>Bonyeza jina la mtumiaji kuona waliojiunga kupitia rufaa yake.</p>
        )}
      </div>
    </div>
  );
};

const cellStyle = {
  padding: 12,
  borderBottom: '1px solid #e2e8f0',
  color: '#172033'
};

export default AdminUsersMember;